export enum StartOrigin {
  HelpMenu = 'manual',
  AppInit = 'automatic',
  DeepLink = 'deeplink',
  Notification = 'notification',
}
